import { Link } from "react-router-dom";
import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { specialTreatments } from "@/mocks/treatments";

const iconMap: Record<string, string> = {
  regenerative: "ri-seedling-line",
  injectables: "ri-syringe-line",
  eye: "ri-eye-line",
};

export default function SpecialTreatments() {
  return (
    <section id="special" className="bg-background-50 py-16 md:py-24 lg:py-28">
      <div className="u-container">
        <Reveal>
          <SectionHeading en="SPECIAL TREATMENTS" jp="専門的な美容医療" />
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:mt-20 lg:grid-cols-3">
          {specialTreatments.map((item, index) => {
            const isFirst = index === 0;
            const isLast = index === specialTreatments.length - 1;
            const colClass = [
              isFirst ? "lg:pr-12" : isLast ? "lg:pl-12" : "lg:px-12",
              index > 0 ? "lg:border-l lg:border-foreground-950/12" : "",
            ]
              .filter(Boolean)
              .join(" ");

            return (
              <Reveal key={item.id} delay={index * 90} className="h-full">
                <Link
                  to={item.href}
                  className={`group flex h-full flex-col border-t border-foreground-950/12 py-9 transition-colors md:py-10 lg:border-t-0 lg:py-2 ${colClass}`}
                >
                  <div className="flex items-center justify-between">
                    <span className="flex h-10 w-10 items-center justify-center text-foreground-600">
                      <i className={`${iconMap[item.id] ?? "ri-leaf-line"} text-xl`} aria-hidden />
                    </span>
                    <span className="font-label text-[11px] tracking-[0.25em] text-secondary-500">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                  </div>

                  <span className="en-eyebrow mt-9 block text-[10px] text-foreground-500">{item.en}</span>
                  <h3 className="mt-4 font-heading text-2xl text-foreground-950">{item.jp}</h3>

                  <ul className="mt-7 space-y-3 border-t border-foreground-950/10 pt-6">
                    {item.lines.map((line) => (
                      <li key={line} className="flex items-start gap-3 text-[13px] leading-[1.9] text-foreground-700">
                        <span className="mt-3 h-px w-4 shrink-0 bg-accent-500" />
                        {line}
                      </li>
                    ))}
                  </ul>

                  <span className="mt-auto inline-flex items-center gap-2 pt-10 text-[12px] text-foreground-900 transition-colors group-hover:text-accent-700 md:text-[13px]">
                    {item.cta}
                    <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" aria-hidden />
                  </span>
                </Link>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}